import { useCappsLandlordUserDetailsWebApiHandler_details } from '@zg-rentals/ts-capps-client-react-query';

export function useGetLandlordUser() {
  return useCappsLandlordUserDetailsWebApiHandler_details();
}
